module.exports = __webpack_public_path__ + "img/why-icon-6.c6eee22a.svg";